import { Input } from "../../../components/ui/input";
import { formatarCentavos } from "../utils/vencimento";

/**
 * Campo de dinheiro que trabalha em centavos inteiros, como o resto da cadeia:
 * a coluna é bigint, a lambda Node exige inteiro, o R lê com bigint="integer64"
 * e o escritor de CNAB só pula o *100 quando o valor chega como inteiro. O
 * bookbinder recusa não-inteiro na cara ("deve ser um inteiro positivo em
 * centavos").
 *
 * Por isso aqui não há parse de decimal em momento nenhum: o que se digita são
 * dígitos, e os dois últimos são os centavos — 123456 vira R$ 1.234,56. Sem
 * float, sem arredondamento e sem depender de o browser usar ponto ou vírgula
 * como separador decimal, que foi o que fez o valor sair 100x maior.
 */

/** Mesmo tamanho do campo monetário do CNAB 444, e bem abaixo de MAX_SAFE_INTEGER. */
const MAX_DIGITOS = 13;

interface InputCentavosProps {
  /** Valor em centavos. */
  valor: number;
  onChange: (centavos: number) => void;
  "aria-label"?: string;
}

export function InputCentavos({ valor, onChange, ...resto }: InputCentavosProps) {
  return (
    <Input
      type="text"
      inputMode="numeric"
      placeholder="R$ 0,00"
      // Vazio quando zero para o placeholder aparecer, em vez de um "R$ 0,00"
      // que o usuário teria de apagar antes de digitar.
      value={valor === 0 ? "" : formatarCentavos(valor)}
      onChange={(e) => {
        const digitos = e.target.value.replace(/\D/g, "").slice(0, MAX_DIGITOS);
        onChange(digitos ? Number(digitos) : 0);
      }}
      {...resto}
    />
  );
}
